export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${encodeURI(cvalue)}; ${expires}; path=/`;
}

export function getCookie(cname) {
  const name = `${cname}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return decodeURI(c.substring(name.length, c.length));
    }
  }
  return '';
}

export function checkCookie() {
  const userId = getCookie('kadroUserId');
  if (userId !== '' && userId !== 'undefined') {
    return userId;
  }
  return null;
}

export function deleteCookie(name) {
  document.cookie = `${name}=;expires=Wed; 01 Jan 1970; path=/`;
}
